import React from "react";

import type { CustomTooltipProps } from "@/types/chart.types";
import { formatDate } from "@/utils/format-date";

export const CustomTooltip: React.FC<CustomTooltipProps> = ({ active, payload, label, valueFormatter }) => {
    if (!active || !payload || !payload.length) return null;

    const shouldShowTooltip = payload.some((item) => item.value !== undefined && item.value !== null);

    if (!shouldShowTooltip) return null;

    const formattedDate = formatDate(label ?? "");
    const formatValue = (value: string | number, dataKey?: string | number) =>
        valueFormatter ? valueFormatter(value, dataKey) : String(value);

    return (
        <div className="bg-background/95 border border-border/50 rounded-lg shadow-lg p-2 space-y-1.5">
            <p className="font-medium text-foreground text-sm">{formattedDate}</p>
            {payload.map((entry, index) => (
                <div key={index} className="flex items-center gap-2">
                    <div className="w-2.5 h-2.5 rounded-full" style={{ backgroundColor: entry.color }} />
                    <span className="text-xs text-muted-foreground">{entry.name}:</span>
                    <span className="text-xs font-medium text-foreground">
                        {formatValue(entry.value, entry.dataKey)}
                    </span>
                </div>
            ))}
        </div>
    );
};
